import script from "./ConfigurationRadioSelection.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigurationRadioSelection.vue?vue&type=script&setup=true&lang=js"

import "./ConfigurationRadioSelection.vue?vue&type=style&index=0&id=838e74ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-838e74ea"]])

export default __exports__